import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	applicationLinkInformationText: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	applicationLinkHowToLinkText: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	cancelButtonText: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	createHeaderText: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	completeButtonText: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	nextButtonText: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	reciprocalRedirectButtonText: {
		defaultMessage: string;
		id: string;
		description: string;
	};
} = defineMessages({
	applicationLinkInformationText: {
		defaultMessage:
			"An application link requires an existing application tunnel or the application's URL. We use either one to connect the application to Jira.",
		id: 'applinks.administration.ui.creation-flow-dialog.application-link-information-text',
		description: 'Info text prior to link that explains what an Applink is.',
	},
	applicationLinkHowToLinkText: {
		defaultMessage: 'How to create an application link',
		id: 'appinks.administration.ui.creation-flow-dialog.application-link-how-to-text',
		description: 'Hyperlink text for the how-to guide in creating an applink.',
	},
	cancelButtonText: {
		defaultMessage: 'Cancel',
		id: 'applinks.administration.ui.creation-flow-dialog.cancel-form-button-text',
		description: 'The button text for cancelling creation of the applink.',
	},
	createHeaderText: {
		defaultMessage: 'Create an application link',
		id: 'applinks.administration.ui.creation-flow-dialog.create-header-text',
		description:
			'Header text for modal dialog for applinks creation flow first step, the creation phase.',
	},
	completeButtonText: {
		defaultMessage: 'Create',
		id: 'applinks.administration.ui.creation-flow-dialog.create-form-button-text',
		description: 'Create button for initializing create locally for applink, on review stage.',
	},
	nextButtonText: {
		defaultMessage: 'Next',
		id: 'applinks.administration.ui.creation-flow-dialog.next-form-button-text',
		description:
			'Next button for continuing creation flow locally for applink, before review stage.',
	},
	reciprocalRedirectButtonText: {
		defaultMessage: 'Finish Setting Up',
		id: 'applinks.administration.ui.creation-flow-dialog.reciprocal-redirect-form-button-text',
		description: 'Redirect button text for sending user to reciprical endpoint for applink setup.',
	},
});
export default messages;
